export default __webpack_public_path__ + "static/media/11.b03ca6a9.jpg";